module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./SetPayPwdView.js"));
	}, "SetPayPwdView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SetPayPwdView!./src/pages/Shop/Member/Wallet/PayPwd/SetPayPwd/SetPayPwdView.js
// module id = 1995
// module chunks = 367